import Vue from 'vue'

import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents)

import 'vue-resize/dist/vue-resize.css'
import _ from 'lodash'
import App from './App.vue'
import Vuex from 'vuex'

import VueResize from 'vue-resize'
Vue.use(VueResize)

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);


import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 0
  },
  mutations: {
    increment (state) {
      state.count++
    }
  }
});


Vue.config.productionTip = false



import VueRouter from 'vue-router'
Vue.use(VueRouter)

import frmBlank from './components/frmBlank/frmBlank.vue'
import frmNoPage from './components/frmNoPage/frmNoPage.vue'
import frmHome from './components/frmHome/frmHome.vue'
import frmKartyaAktivalas from './components/frmKartyaAktivalas/frmKartyaAktivalas.vue'
import frmBefizetes from './components/frmBefizetes/frmBefizetes.vue'
import frmPmt from './components/frmPmt/frmPmt.vue'
import frmSzolgKeres from './components/frmSzolgKeres/frmSzolgKeres.vue'
import frmCsodakartya from './components/frmCsodakartya/frmCsodakartya.vue'
import frmCsodakartya_veglegesites from './components/frmCsodakartya/frmCsodakartya_veglegesites.vue'
import frmVPOS from './components/frmVPOS/frmVPOS.vue'
import frmMedicall_Redir from './components/frmMedicall/frmMedicall_Redir.vue'
import frmMedicall_UserData from './components/frmMedicall/frmMedicall_UserData.vue'
import frmMGM from './components/frmMGM/frmMGM.vue'
import frmSZJA2021 from './components/frmSZJA2021/frmSZJA2021.vue'
import frmIratkuldoSzolgaltatas from './components/frmIratkuldoSzolgaltatas/frmIratkuldoSzolgaltatas.vue'

const routes = [
  { path: '/blank', component: frmBlank },
  { path: '/nopage', component: frmNoPage },  

  { path: '/home', component: frmHome },
  { path: '/kartyaaktivalas', component: frmKartyaAktivalas },    
  { path: '/befizetes', component: frmBefizetes },    
  { path: '/pmt', component: frmPmt },   
  { path: '/szolgaltato_kereso', component: frmSzolgKeres },   
  { path: '/csodakartya', component: frmCsodakartya },   
  { path: '/csodakartya_veglegesites', component: frmCsodakartya_veglegesites },   
  { path: '/vpos', component: frmVPOS },   
  { path: '/mcredir', component: frmMedicall_Redir },   
  { path: '/mcuserdata', component: frmMedicall_UserData },   
  { path: '/mgm', component: frmMGM },   
  { path: '/szja2021', component: frmSZJA2021 },   
  { path: '/iratkuldo_szolgaltatas', component: frmIratkuldoSzolgaltatas },   

  
  
];

const router = new VueRouter({
  mode: 'hash',
  routes, // short for `routes: routes`
  scrollBehavior() {
    return {x: 0, y: 0}
  }  
})

router.beforeEach((to, from, next) => {

  /*
  console.log("rt from:");
  console.log(from);
  console.log("rt to:");
  console.log(to);
  */

  grcmain_SetBodyScrollable(true);

  if (gMegaMenuVisible || gUserMenuVisible)
  {
    //CloseMegaMenu();
    CloseTopMenus();
    next(false);
    return;
  }
  
  if ((gForm != null)&&(gPopupControlName != ""))
  {
    ClosePopup(gPopupControlName);
    next(false);
    return;
  }
  
  
  gForm = null;
  gPopupControlName = "";

  next();
  
})

router.afterEach((to, from) => {

})

var app = new Vue({
  render: h => h(App),
  router
}).$mount('#app')



